module.exports = __webpack_public_path__ + "static/media/compound.38205c7e.svg";